import { t } from 'i18next';
import Button from 'shared/components/form/button';
import './styles.scss';

interface BetBuilderBasketFooterProps {
	onAddBetToCoupon: () => void;
	totalOdds: number;
	isMoreThenOneBetbuilderEvent: boolean;
}

const BetBuilderBasketFooter = ({ onAddBetToCoupon, totalOdds, isMoreThenOneBetbuilderEvent }: BetBuilderBasketFooterProps) => {
	return (
		<>
			{isMoreThenOneBetbuilderEvent ? (
				<div className="BetbuilderOverview__buttonWrapper">
					<Button
						btnType="secondary"
						btnHeight="small"
						onClick={() => onAddBetToCoupon()}
						disabled={totalOdds <= 0}
						className="button button--secondary add-btn"
						cyTestRef="betbuilder-add"
					>
						{t('addToCoupan')}
					</Button>
				</div>
			) : (
				<span className="BetbuilderOverview__text">{t('betBuilderAddEventText')}</span>
			)}
		</>
	);
};

export default BetBuilderBasketFooter;
